// Rinnova gift-card configurator — maps denomination buttons to real product
// variants, syncs the selected variant id into the add-to-cart form, and
// updates the visual card preview + total.
class RinnovaGiftcard extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-rinnova-gc-amount]'));
    this.variantInput = this.querySelector('[ref="variantId"]');
    this.amountEl = this.querySelector('[data-rinnova-gc-display]');
    this.totalEl = this.querySelector('[data-rinnova-gc-total]');

    this.onClick = this.onClick.bind(this);
    this.buttons.forEach((btn) => btn.addEventListener('click', this.onClick));

    // Select the button matching the form's initial variant, else the first.
    const initial =
      this.buttons.find((b) => b.dataset.variantId === (this.variantInput && this.variantInput.value)) ||
      this.buttons[0];
    if (initial) this.select(initial);
  }

  disconnectedCallback() {
    this.buttons.forEach((btn) => btn.removeEventListener('click', this.onClick));
  }

  onClick(event) {
    this.select(event.currentTarget);
  }

  select(btn) {
    this.buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
    if (this.variantInput && btn.dataset.variantId) {
      this.variantInput.value = btn.dataset.variantId;
    }
    if (this.amountEl && btn.dataset.display) {
      this.amountEl.textContent = btn.dataset.display;
    }
    if (this.totalEl && btn.dataset.total) {
      this.totalEl.textContent = btn.dataset.total;
    }
  }
}

if (!customElements.get('rinnova-giftcard')) {
  customElements.define('rinnova-giftcard', RinnovaGiftcard);
}
